import React from 'react';
export function HonestLine() {
  return <section className="bg-paper py-[42px]" data-id="element-57">
      <div className="max-w-page mx-auto px-6" data-id="element-58">
        <p className="max-w-[760px] mx-auto text-center text-[0.95rem] text-ink-60 m-0" data-id="element-59">
          <b className="text-ink font-display italic font-medium" data-id="element-60">
            The honest line:
          </b>{' '}
          Chime isn't a cure for anxiety, and it's not a replacement for therapy
          or medication. It's a fast, physical way to take the edge off and a
          healthier thing to reach for in a hard moment — best used as a daily
          habit, not a one-time rescue. If you have a breathing condition like
          asthma, check with your doctor first.
        </p>
      </div>
    </section>;
}